export enum FuelTypeMoneyEnum {
    GNV = 'Soles',
    GLP = 'Soles',
    GASOLINA = 'Soles',
    ELECTRICIDAD = 'Horas Carga'
}